export const ADMIN_EMAIL_COUNTS_REFRESH_MS = 60_000;
export const ADMIN_EMAIL_PAGE_SIZE = 50;
export const ADMIN_EMAIL_BODY_CHUNK_SIZE = 20_000;
export const ADMIN_EMAIL_MAX_RANGE_DAYS = 31;
export const ADMIN_EMAIL_DAY_MS = 86_400_000;

export const ADMIN_EMAIL_CONTROL_CLASS =
  "h-9 rounded border border-gray-300 bg-transparent px-3 text-sm outline-none focus-visible:border-green dark:border-gray-600";

export const ADMIN_EMAIL_ACTION_CLASS =
  "inline-flex h-9 items-center justify-center gap-2 rounded border border-gray-300 px-3 text-sm font-semibold hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-40 dark:border-gray-600 dark:hover:bg-gray-700";
